/**
 * Selectors
 */
const selectFontForSvg = (list, font) => {
  var svgFont = [];
  if (font.id) {
    svgFont = list.filter((listFont) => listFont.id === font.id);
  }
  if (svgFont && svgFont.length) return { ...font, ...svgFont[0] };
  return font;
};
const selectFontsForForm = (fonts) => {
  return fonts.map((font) => {
    return {
      id: font.id,
      title: font.title,
      preview: font.preview,
      min_font_size: font.min_font_size,
      styles: font.styles.map((style) => {
        return {
          title: style.title,
          loaded: style.loaded,
          available: style.available,
        };
      }),
    };
  });
};

/** exports all actions as default */
const fontSelectors = {
  selectFontForSvg: selectFontForSvg,
  selectFontsForForm: selectFontsForForm,
};

export default fontSelectors;
